export const creditCardCreditLimitChangeExternal = {
    targetClientId: '',
};
